import { useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { MultiSelect } from 'react-multi-select-component'
import { GETLANGUAGE, GET_ALL_SMART_DOCS_AND_FILTER } from '../../../../../utils/GraphQLAPI'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'
import {
    MultiSelectOption,
    DocType,
    LanguageType
} from './AddProductUtils'
import './SmartDocs.css'

type Props = {
    formik: any
    handleSelectedItem: (e: any, fieldName: string) => void
    setSelectedDocs: React.Dispatch<React.SetStateAction<
        Record<LanguageType, Record<DocType, MultiSelectOption[]>>
    >>,
    selectedDocs: Record<LanguageType, Record<DocType, MultiSelectOption[]>>
    selectedEnglish: MultiSelectOption[]
    selectedSpanish: MultiSelectOption[]
    setEnglish: React.Dispatch<React.SetStateAction<MultiSelectOption[]>>
    setSpanish: React.Dispatch<React.SetStateAction<MultiSelectOption[]>>
}


const AssingedSmartDocsSection = ({ formik, handleSelectedItem, setSelectedDocs, selectedDocs, selectedEnglish, selectedSpanish, setEnglish, setSpanish }: Props) => {

    const updateSelectedDocs = (
        language: LanguageType,
        type: DocType,
        value: MultiSelectOption[]
    ) => {
        setSelectedDocs(prev => ({
            ...prev,
            [language]: {
                ...prev[language],
                [type]: value,
            }
        }));
    };

    const [getAllLanguages] = useLazyQuery(GETLANGUAGE, {
        onCompleted: (data) => {
            const langs = data.getAllLanguages.map((language: any) => ({
                id: language.id,
                value: language.languageName,
            }))

            const hasEnglish = langs.some(
                (lang: any) => lang.value === 'English'
            )
            const hasSpanish = langs.some(
                (lang: any) => lang.value === 'Spanish'
            )
            if (hasEnglish) {
                formik.setFieldValue('Language', 'English')
            }
            if (hasSpanish) {
                formik.setFieldValue('Language2', 'Spanish')
            }
        },
    })

    const [getSmartDocs] = useLazyQuery(GET_ALL_SMART_DOCS_AND_FILTER, {
        variables: {
            filter: {
                page: 1,
                limit: 100,
                searchQuery: '',
                documentStatus: null,
                commodityId: null,
                contractTypeId: null,
                utilityId: null,
                state: null,
            }

        },
        onCompleted: (data) => {
            const english: MultiSelectOption[] = []
            const spanish: MultiSelectOption[] = []

            data?.fetchAllSmartDocuments?.data?.forEach((doc: any) => {
                if (!doc.isActive || !doc.language) return

                if (doc.language.languageName === 'English') {
                    english.push({
                        value: doc.smartDocId,
                        label: doc.documentName,
                    })
                }

                if (doc.language.languageName === 'Spanish') {
                    spanish.push({
                        value: doc.smartDocId,
                        label: doc.documentName,
                    })
                }
            })

            setEnglish(english)
            setSpanish(spanish)

        },

        onError: (err) => console.log('error', err),
        fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    })

    useEffect(() => {
        getAllLanguages()
        getSmartDocs()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return <div className='pb-3 pt-10'>
        <h4 className="mt-4 fw-bold text-brand-blue">
            SmartDocs Section
        </h4>
        <div className='d-flex justify-content-between align-items-center mt-3'>
            <h5 className='fw-bold fs-6 mt-3 mb-0'>English Documents</h5>
        </div>
        <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
            <Col sm md lg={4}>
                <p className='fw-semibold '>Terms and Conditions</p>
                <MultiSelect
                    options={selectedEnglish}
                    value={selectedDocs.English.tmc}
                    onChange={(val: MultiSelectOption[]) =>
                        updateSelectedDocs('English', 'tmc', val)
                    }
                    className='create-script-dropdown'
                    labelledBy='Select'
                />
            </Col>
            <Col sm md lg={4}> <p className='fw-semibold fs-6 '>Disclosure Statement</p>
                <MultiSelect
                    options={selectedEnglish}
                    value={selectedDocs.English.dsc}
                    onChange={(val: MultiSelectOption[]) =>
                        updateSelectedDocs('English', 'dsc', val)

                    }
                    className='create-script-dropdown'
                    labelledBy='Select'
                /></Col>
            <Col sm md lg={4}>
                <p className='fw-semibold fs-6 '>Other</p>
                <MultiSelect
                    options={selectedEnglish}
                    value={selectedDocs.English.other}
                    onChange={(val: MultiSelectOption[]) =>
                        updateSelectedDocs('English', 'other', val)

                    }
                    className='create-script-dropdown'
                    labelledBy='Select'
                />
            </Col>

        </Row>

        <div className='d-flex justify-content-between align-items-center mt-3'>
            <h5 className='fw-bold fs-6'>Spanish Documents</h5>
        </div>
        <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
            <Col sm md lg={4}>
                <p className='fw-semibold fs-6'>Terms and Conditions</p>
                <MultiSelect
                    options={selectedSpanish}
                    value={selectedDocs.Spanish.tmc}
                    onChange={(val: MultiSelectOption[]) =>
                        updateSelectedDocs('Spanish', 'tmc', val)

                    }
                    className='create-script-dropdown'
                    labelledBy='Select'
                /></Col>
            <Col sm md lg={4}>
                <p className='fw-semibold fs-6 '>Disclosure Statement</p>
                <MultiSelect
                    options={selectedSpanish}
                    value={selectedDocs.Spanish.dsc}
                    onChange={(val: MultiSelectOption[]) =>
                        updateSelectedDocs('Spanish', 'dsc', val)

                    }
                    className='create-script-dropdown'
                    labelledBy='Select'
                />
            </Col>
            <Col sm md lg={4}>
                <p className='fw-semibold fs-6 '>Other</p>
                <MultiSelect
                    options={selectedSpanish}
                    value={selectedDocs.Spanish.other}
                    onChange={(val: MultiSelectOption[]) =>
                        updateSelectedDocs('Spanish', 'other', val)

                    }
                    className='create-script-dropdown'
                    labelledBy='Select'
                />
            </Col>
        </Row>

    </div>;
}
export default AssingedSmartDocsSection;